module.exports = __webpack_public_path__ + "img/symbol_4.8f60d6a5.png";